@if((alwaysShow || type != null) && display != null) {
<span
    *ngIf="layout === 'INLINE'"
    class="status-block"
    [ngClass]="display.statusClass"
    >{{ display.label }}</span
>
<span
    *ngIf="layout === 'INDICATOR'"
    class="status-circle"
    [ngClass]="display.statusClass"
    [tooltip]="display.label"
    placement="top"
></span>
}
